module.exports = __webpack_public_path__ + "img/3ed9558.jpg";